import actions from '~/store/modules/shared/dealers/site/layout/actions'
import mutations from '~/store/modules/shared/dealers/site/layout/mutations'
import state from '~/store/modules/shared/dealers/site/layout/state'
import { createModule } from '~/factories/store'

export default createModule({
  actions,
  mutations,
  state
})
